export default __webpack_public_path__ + "static/media/sync-clouds-citron.d804aa9d.svg";